import { getWhatsappClickToChat } from '@global/utils/url/create-whatsapp-url';
import { GatsbyButton } from '@lp-root/src/components/atm.button/button.component';
import LargeSeparatorRow from '@lp-root/src/components/atm.large-separator-row/large-separator-row.component';
import { EmojiTitleDescription } from '@lp-root/src/components/mol.emoji-title-description/emoji-text-vertical.component';
import { Body, Col, FeaturedH2, Grid, LargeSeparator, Row, Separator } from '@web/atomic';
import { CardWrapper } from '@web/atomic/atm.wrapper/wrapper.component';
import { Fade } from '@web/atomic/legacy/obj.animation/animation.component.style';
import * as React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';

interface IHcpLandingPagePartnershipSectionProps {
  progress: number;
}
const HcpLandingPagePartnershipSection: React.FunctionComponent<IHcpLandingPagePartnershipSectionProps> = (props) => {
  const { t } = useTranslation('health-carer-landing-page');
  return (
    <Grid>
      <Row>
        <Col xs={12}>
          <FeaturedH2>{t('partnership_title')}</FeaturedH2>
        </Col>
      </Row>
      <Row center={'xs'} mb>
        <Col xs={12} md={8} lg={6}>
          <Body>{t('partnership_description')}</Body>
        </Col>
      </Row>
      <Row center={'xs'}>
        <Col xs={false} md={10}>
          <SvgPartnershipComponent {...props} />
        </Col>
        <Col xs={12} md={false}>
          <CardWrapper>
            <Row center={'xs'}>
              <Col xs={12}>
                <Separator />
                {[
                  {
                    emoji: '👥',
                    description: t('partnership_steps_consultations'),
                  },
                  {
                    emoji: '📱',
                    description: t('partnership_steps_app'),
                  },
                  {
                    emoji: '‍📊',
                    description: t('partnership_steps_reports'),
                  },
                ].map((item, i) => (
                  <EmojiTitleDescription key={i} {...item} />
                ))}
                <LargeSeparator />
              </Col>
            </Row>
          </CardWrapper>
        </Col>
      </Row>
      <LargeSeparatorRow />
      <Row mb mt center="xs">
        <Col xs={12} sm={6} md={4}>
          <GatsbyButton id="ga-hcp-landing-page-know-more" kind="primary" expanded external to={getWhatsappClickToChat('sales')}>
            {t('partnership_ctaKnowMore')}
          </GatsbyButton>
        </Col>
      </Row>
      <LargeSeparatorRow />
    </Grid>
  );
};

export default HcpLandingPagePartnershipSection;

function SvgPartnershipComponent(props: IHcpLandingPagePartnershipSectionProps) {
  const { t } = useTranslation('health-carer-landing-page');
  return (
    <svg viewBox="0 0 954 591" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <Fade as={'g' as any} show={props.progress > 0} id="svg-partnership--upper-box">
        <path
          id="Vector_81"
          d="M325.857 184.573H323.263C322.019 184.573 321.016 185.588 321.016 186.83C321.016 188.079 322.026 189.087 323.263 189.087H325.857C327.102 189.087 328.105 188.072 328.105 186.83C328.105 185.588 327.094 184.573 325.857 184.573Z"
          fill="#112129"
        />
        <path
          id="Vector_82"
          d="M334.304 184.573H333.98C333.037 184.573 332.275 185.338 332.275 186.285V187.375C332.275 188.322 333.037 189.087 333.98 189.087H334.304C335.247 189.087 336.009 188.322 336.009 187.375V186.285C336.009 185.346 335.247 184.573 334.304 184.573Z"
          fill="#112129"
        />
        <text
          id="patient-consultations"
          fill="#050D3D"
          xmlSpace="preserve"
          style={{
            whiteSpace: 'pre',
          }}
          fontFamily="Montserrat"
          fontSize={14}
          fontWeight={600}
          letterSpacing="0px"
        >
          <tspan x={390.56} y={191.497} textAnchor="middle">
            {t('partnership_steps_consultations')}
          </tspan>
        </text>
        <rect id="Rectangle 82" x={338} y={74.4775} width={278} height={225} rx={11} stroke="#050D3D" strokeWidth={4} />
        <path
          id="Vector_83"
          d="M303.889 197.522C304.764 196.644 304.764 195.213 303.889 194.327L302.509 192.941C301.091 191.517 302.094 189.086 304.1 189.086H314.93C316.174 189.086 317.177 188.079 317.177 186.829C317.177 185.58 316.174 184.573 314.93 184.573H304.108C302.101 184.573 301.098 182.142 302.516 180.718L303.896 179.332C304.771 178.454 304.771 177.022 303.896 176.136C303.022 175.258 301.596 175.258 300.714 176.136L291.656 185.224C290.781 186.102 290.781 187.534 291.656 188.42L300.714 197.522C301.589 198.401 303.014 198.401 303.889 197.522Z"
          fill="#112129"
        />
        <path
          id="Vector_84"
          d="M646.12 176.433C645.245 177.311 645.245 178.743 646.12 179.629L647.5 181.014C648.918 182.438 647.915 184.869 645.909 184.869L635.079 184.869C633.834 184.869 632.831 185.876 632.831 187.126C632.831 188.375 633.834 189.382 635.079 189.382L645.901 189.382C647.907 189.382 648.91 191.813 647.493 193.237L646.112 194.623C645.238 195.501 645.238 196.933 646.112 197.819C646.987 198.697 648.413 198.697 649.295 197.819L658.353 188.731C659.228 187.853 659.228 186.421 658.353 185.535L649.295 176.433C648.42 175.554 646.995 175.554 646.12 176.433Z"
          fill="#112129"
        />
        <path
          id="Vector_85"
          d="M624.151 189.382L626.746 189.382C627.99 189.382 628.993 188.367 628.993 187.125C628.993 185.876 627.983 184.869 626.746 184.869L624.151 184.869C622.907 184.869 621.904 185.883 621.904 187.125C621.904 188.367 622.915 189.382 624.151 189.382Z"
          fill="#112129"
        />
        <path
          id="Vector_86"
          d="M615.705 189.382L616.029 189.382C616.972 189.382 617.733 188.617 617.733 187.671L617.733 186.58C617.733 185.634 616.972 184.869 616.029 184.869L615.705 184.869C614.762 184.869 614 185.634 614 186.58L614 187.671C614 188.61 614.762 189.382 615.705 189.382Z"
          fill="#112129"
        />
      </Fade>

      <Fade as={'g' as any} show={props.progress > 2 / 5} id="svg-partnership--bottom-box">
        <path
          id="Vector"
          d="M122.059 346.427C122.933 347.306 124.358 347.306 125.24 346.427L126.619 345.041C128.036 343.616 130.455 344.624 130.455 346.639L130.455 357.52C130.455 358.771 131.458 359.779 132.702 359.779C133.945 359.779 134.948 358.771 134.948 357.52L134.948 346.647C134.948 344.631 137.367 343.624 138.784 345.048L140.163 346.435C141.038 347.314 142.462 347.314 143.344 346.435C144.219 345.556 144.219 344.124 143.344 343.237L134.299 334.137C133.425 333.258 132.001 333.258 131.119 334.137L122.059 343.237C121.185 344.116 121.185 345.548 122.059 346.427Z"
          fill="#050D3D"
        />
        <path
          id="Vector_2"
          d="M134.948 368.5L134.948 365.893C134.948 364.643 133.938 363.635 132.702 363.635C131.458 363.635 130.455 364.651 130.455 365.893L130.455 368.5C130.455 369.75 131.465 370.758 132.702 370.758C133.938 370.758 134.948 369.743 134.948 368.5Z"
          fill="#050D3D"
        />
        <path
          id="Vector_3"
          d="M134.948 376.986L134.948 376.66C134.948 375.713 134.186 374.947 133.244 374.947L132.159 374.947C131.217 374.947 130.455 375.713 130.455 376.66L130.455 376.986C130.455 377.933 131.217 378.698 132.159 378.698L133.244 378.698C134.179 378.698 134.948 377.933 134.948 376.986Z"
          fill="#050D3D"
        />
        <rect id="Rectangle 84" y={361.478} width={954} height={229} rx={17} fill="#050D3D" />
        <text
          id="vigilantes-brand"
          fill="white"
          xmlSpace="preserve"
          style={{
            whiteSpace: 'pre',
          }}
          fontFamily="Montserrat"
          fontSize={16}
          fontWeight={600}
          letterSpacing="0px"
        >
          <tspan x={400} y={552.214}>
            {t('partnership_vigilantesBrand')}
          </tspan>
        </text>
        <path
          id="Fill 1"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M477.639 511.664H474.149C469.709 511.664 466.111 508.065 466.111 503.626C466.111 499.187 469.709 495.588 474.149 495.588H477.639C482.079 495.588 485.677 499.187 485.677 503.626C485.677 508.065 482.079 511.664 477.639 511.664Z"
          fill="white"
        />
        <path
          id="Stroke 3"
          d="M485.202 513.017C485.794 511.932 487.154 511.533 488.239 512.125C489.324 512.718 489.723 514.077 489.131 515.162C486.94 519.174 481.705 521.728 475.894 521.728C470.083 521.728 464.848 519.174 462.657 515.162C462.065 514.077 462.464 512.718 463.549 512.125C464.544 511.582 465.769 511.873 466.422 512.76L466.586 513.017C467.916 515.453 471.603 517.252 475.894 517.252C479.947 517.252 483.46 515.648 484.959 513.417L485.202 513.017Z"
          fill="white"
        />
        <path
          id="Combined Shape"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M521.442 476.482C535.82 476.482 547.476 464.827 547.476 450.448C547.476 436.07 535.82 424.415 521.442 424.415C507.064 424.415 495.408 436.07 495.408 450.448C495.408 464.827 507.064 476.482 521.442 476.482ZM525.879 472.949C535.02 472.949 542.429 465.54 542.429 456.4C542.429 447.261 535.02 439.851 525.879 439.851C516.74 439.851 509.331 447.261 509.331 456.4C509.331 465.54 516.74 472.949 525.879 472.949Z"
          fill="white"
        />
        <path
          id="Combined Shape_2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M430.346 476.482C415.969 476.482 404.312 464.827 404.312 450.448C404.312 436.07 415.969 424.415 430.346 424.415C444.724 424.415 456.38 436.07 456.38 450.448C456.38 464.827 444.724 476.482 430.346 476.482ZM425.909 472.949C416.769 472.949 409.36 465.54 409.36 456.4C409.36 447.261 416.769 439.851 425.909 439.851C435.048 439.851 442.457 447.261 442.457 456.4C442.457 465.54 435.048 472.949 425.909 472.949Z"
          fill="white"
        />
        <path
          id="Fill 13"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M539.543 474.448C539.543 452.999 511.046 435.613 475.895 435.613C440.742 435.613 412.246 452.999 412.246 474.448C412.246 474.676 412.249 474.903 412.256 475.131C412.249 475.384 412.246 475.639 412.246 475.894C412.246 492.159 425.365 505.345 441.548 505.345C450.077 505.345 457.754 501.682 463.108 495.836L463.115 495.844C466.343 492.491 470.873 490.402 475.895 490.402C480.985 490.402 485.57 492.548 488.805 495.982L488.814 495.981C494.163 501.742 501.783 505.345 510.241 505.345C526.424 505.345 539.543 492.159 539.543 475.894C539.543 475.612 539.538 475.331 539.53 475.052C539.535 474.85 539.543 474.65 539.543 474.448Z"
          fill="white"
        />
        <text
          fill="white"
          xmlSpace="preserve"
          style={{
            whiteSpace: 'pre',
          }}
          fontFamily="Montserrat"
          fontSize={14}
          fontWeight={600}
          letterSpacing="0px"
        >
          <tspan x={710} y={480.497} textAnchor="middle">
            {t('partnership_appDescription')}
          </tspan>
        </text>
      </Fade>

      <Fade as={'g' as any} show={props.progress > 2 / 5}>
        <text
          fill="white"
          xmlSpace="preserve"
          style={{
            whiteSpace: 'pre',
          }}
          fontFamily="Montserrat"
          fontSize={14}
          fontWeight={600}
          letterSpacing="0px"
        >
          <tspan x={130} y={480.497} textAnchor="middle">
            {t('partnership_reportsDescription')}
          </tspan>
        </text>
        <path
          id="Vector_12"
          d="M786.656 346.427C787.53 347.306 788.954 347.306 789.836 346.427L791.216 345.041C792.633 343.616 795.052 344.624 795.052 346.639L795.052 357.52C795.052 358.771 796.055 359.779 797.298 359.779C798.542 359.779 799.544 358.771 799.544 357.52L799.544 346.647C799.544 344.631 801.964 343.624 803.381 345.048L804.76 346.435C805.635 347.314 807.059 347.314 807.941 346.435C808.815 345.556 808.815 344.124 807.941 343.237L798.896 334.137C798.022 333.258 796.597 333.258 795.715 334.137L786.656 343.237C785.781 344.116 785.781 345.548 786.656 346.427Z"
          fill="#050D3D"
        />
        <path
          id="Vector_13"
          d="M799.544 368.5L799.544 365.893C799.544 364.643 798.534 363.635 797.298 363.635C796.055 363.635 795.052 364.651 795.052 365.893L795.052 368.5C795.052 369.75 796.062 370.758 797.298 370.758C798.534 370.758 799.544 369.743 799.544 368.5Z"
          fill="#050D3D"
        />
        <path
          id="Vector_14"
          d="M799.544 376.986L799.544 376.66C799.544 375.713 798.783 374.947 797.841 374.947L796.756 374.947C795.813 374.947 795.052 375.713 795.052 376.66L795.052 376.986C795.052 377.933 795.813 378.698 796.756 378.698L797.841 378.698C798.776 378.698 799.544 377.933 799.544 376.986Z"
          fill="#050D3D"
        />
        <path
          id="Vector_15"
          d="M799.544 368.5L799.544 365.894C799.544 364.644 798.534 363.636 797.298 363.636C796.055 363.636 795.052 364.651 795.052 365.894L795.052 368.5C795.052 369.751 796.062 370.758 797.298 370.758C798.534 370.758 799.544 369.743 799.544 368.5Z"
          fill="white"
        />
      </Fade>

      <path
        id="Vector_4"
        d="M318.889 486.522C319.764 485.644 319.764 484.213 318.889 483.327L317.509 481.941C316.091 480.517 317.094 478.086 319.1 478.086H329.93C331.174 478.086 332.177 477.079 332.177 475.829C332.177 474.58 331.174 473.573 329.93 473.573H319.108C317.101 473.573 316.098 471.142 317.516 469.718L318.896 468.332C319.771 467.454 319.771 466.022 318.896 465.136C318.022 464.258 316.596 464.258 315.714 465.136L306.656 474.224C305.781 475.102 305.781 476.534 306.656 477.42L315.714 486.522C316.589 487.401 318.014 487.401 318.889 486.522Z"
        fill="white"
      />
      <path
        id="Vector_5"
        d="M340.857 473.573H338.263C337.019 473.573 336.016 474.588 336.016 475.83C336.016 477.079 337.026 478.086 338.263 478.086H340.857C342.102 478.086 343.105 477.072 343.105 475.83C343.105 474.588 342.094 473.573 340.857 473.573Z"
        fill="white"
      />
      <path
        id="Vector_6"
        d="M349.304 473.573H348.98C348.037 473.573 347.275 474.338 347.275 475.285V476.375C347.275 477.322 348.037 478.087 348.98 478.087H349.304C350.247 478.087 351.009 477.322 351.009 476.375V475.285C351.009 474.346 350.247 473.573 349.304 473.573Z"
        fill="white"
      />
      <path
        id="Vector_7"
        d="M134.948 368.5L134.948 365.894C134.948 364.644 133.938 363.636 132.702 363.636C131.458 363.636 130.455 364.651 130.455 365.894L130.455 368.5C130.455 369.751 131.465 370.758 132.702 370.758C133.938 370.758 134.948 369.743 134.948 368.5Z"
        fill="white"
      />
      <path
        id="Vector_8"
        d="M134.948 376.986L134.948 376.66C134.948 375.713 134.186 374.948 133.244 374.948L132.159 374.948C131.217 374.948 130.455 375.713 130.455 376.66L130.455 376.986C130.455 377.933 131.217 378.698 132.159 378.698L133.244 378.698C134.179 378.698 134.948 377.933 134.948 376.986Z"
        fill="white"
      />
      <path
        id="Vector_9"
        d="M631.12 465.433C630.245 466.311 630.245 467.743 631.12 468.629L632.5 470.014C633.918 471.438 632.915 473.869 630.909 473.869L620.079 473.869C618.834 473.869 617.831 474.876 617.831 476.126C617.831 477.375 618.834 478.382 620.079 478.382L630.901 478.382C632.907 478.382 633.91 480.813 632.493 482.237L631.112 483.623C630.238 484.501 630.238 485.933 631.112 486.819C631.987 487.697 633.413 487.697 634.295 486.819L643.353 477.731C644.228 476.853 644.228 475.421 643.353 474.535L634.295 465.433C633.42 464.554 631.995 464.554 631.12 465.433Z"
        fill="white"
      />
      <path
        id="Vector_10"
        d="M609.151 478.382L611.746 478.382C612.99 478.382 613.993 477.367 613.993 476.125C613.993 474.876 612.983 473.869 611.746 473.869L609.151 473.869C607.907 473.869 606.904 474.883 606.904 476.125C606.904 477.367 607.915 478.382 609.151 478.382Z"
        fill="white"
      />
      <path
        id="Vector_11"
        d="M600.705 478.382L601.029 478.382C601.972 478.382 602.733 477.617 602.733 476.671L602.733 475.58C602.733 474.634 601.972 473.869 601.029 473.869L600.705 473.869C599.762 473.869 599 474.634 599 475.58L599 476.671C599 477.61 599.762 478.382 600.705 478.382Z"
        fill="white"
      />
      <path
        id="Vector_16"
        d="M799.544 376.986L799.544 376.66C799.544 375.713 798.783 374.948 797.841 374.948L796.756 374.948C795.813 374.948 795.052 375.713 795.052 376.66L795.052 376.986C795.052 377.933 795.813 378.698 796.756 378.698L797.841 378.698C798.776 378.698 799.544 377.933 799.544 376.986Z"
        fill="white"
      />
      <g id="svg-partnership--doctor">
        <text
          fill="#050D3D"
          xmlSpace="preserve"
          style={{
            whiteSpace: 'pre',
          }}
          fontFamily="Montserrat"
          fontSize={16}
          fontWeight={600}
          letterSpacing="0px"
        >
          <tspan x={41} y={311.214}>
            {t('partnership_professional')}
          </tspan>
        </text>
        <g id="Mask Group">
          <mask id="mask0" maskUnits="userSpaceOnUse" x={17} y={0} width={225} height={284}>
            <rect id="Rectangle 80" x={17} y={0.477539} width={225} height={283} fill="#C4C4C4" />
          </mask>
          <g mask="url(#mask0)">
            <g id="M&#195;&#169;dico">
              <path
                id="Vector_17"
                d="M151.799 60.4682L150.769 83.8006C150.511 90.1835 145.274 95.1864 138.921 95.1864H136.947V103.165L151.756 104.459L152.314 110.54C152.314 110.54 126.988 124.6 118.704 110.54L119.562 100.577L118.704 60.4682L126.001 53.999L151.756 59.39V60.4682H151.799Z"
                fill="#F9BC60"
              />
              <path
                id="Path Copy 21"
                d="M158.204 107.011C128.842 127.708 104.09 105.455 104.09 105.455L99.8593 107.011C94.8092 108.863 90.3632 112.16 87.1878 116.495C81.9676 123.698 76.165 135.944 79.801 152.222C79.8546 152.524 79.4324 152.695 79.3066 152.416L78.6862 151.175C78.457 150.688 77.8754 150.471 77.4034 150.738C76.9924 150.945 76.8268 151.435 76.9613 151.871C77.8633 154.539 81.9883 178.749 87.1876 186.493C95.0778 188.458 100.088 189.687 100.088 189.687C104.617 187.042 107.499 181.244 107.499 181.244C107.51 181.28 109.128 182.29 109.128 182.29C133.691 197.749 158.204 184.817 158.204 184.817L161.76 170.681C167.117 177.778 174.807 170.566 174.807 170.566C170.804 172.091 172.495 187.259 172.495 187.259C192.72 196.101 185.608 174.752 185.608 174.752C185.42 117.678 158.204 107.011 158.204 107.011Z"
                fill="#FDEFE3"
              />
              <path
                id="Vector_18"
                d="M161.286 185.152L225.674 430.982L165.149 452.33L141.325 251.138V317.986C141.325 330.537 133.17 341.664 121.193 345.33L31.8656 372.802L17.7002 312.638L100.117 310.698L89.171 204.603L107.2 185.195H161.286V185.152Z"
                fill="#114067"
              />
              <g id="Group">
                <g id="Group_2">
                  <path id="Vector_19" d="M161.286 185.152L219.836 447.155" stroke="white" strokeWidth={2} strokeMiterlimit={10} />
                  <path id="Vector_20" d="M152.357 185.152L205.971 447.155" stroke="white" strokeWidth={2} strokeMiterlimit={10} />
                  <path id="Vector_21" d="M143.901 185.152L197.343 462.034" stroke="white" strokeWidth={2} strokeMiterlimit={10} />
                  <path id="Vector_22" d="M137.333 185.152L179.142 462.034" stroke="white" strokeWidth={2} strokeMiterlimit={10} />
                  <path
                    id="Vector_23"
                    d="M130.766 185.152L133.856 312.035C134.243 328.466 122.91 342.871 106.899 346.278L24.8257 363.702"
                    stroke="white"
                    strokeWidth={2}
                    strokeMiterlimit={10}
                  />
                  <path
                    id="Vector_24"
                    d="M124 185.27L123.527 313.968C123.484 325.418 114.837 335.185 103.05 337.155L2 354.063"
                    stroke="white"
                    strokeWidth={2}
                    strokeMiterlimit={10}
                  />
                  <path
                    id="Vector_25"
                    d="M114.754 181.701V313.501C114.754 320.229 109.775 325.922 103.122 326.784L17.5283 337.609"
                    stroke="white"
                    strokeWidth={2}
                    strokeMiterlimit={10}
                  />
                  <path
                    id="Vector_26"
                    d="M102.564 187.307L106.556 311.904C106.684 315.484 103.98 318.546 100.417 318.805L10.832 325.749"
                    stroke="white"
                    strokeWidth={2}
                    strokeMiterlimit={10}
                  />
                </g>
              </g>
              <path
                id="Vector_27"
                d="M51.0102 251.18L48.263 274.081C48.1342 275.332 48.821 276.496 49.98 276.971L51.6112 277.618L51.9116 280.206C52.0404 281.499 52.9848 282.534 54.1867 282.879L56.2042 283.44C56.5905 285.51 58.2646 287.02 60.368 287.192H60.4538C61.6128 287.279 62.6001 286.416 62.6859 285.252L63.9737 285.338C65.7336 285.467 67.279 284.173 67.5365 282.405L68.6955 273.219L70.2408 273.478C71.9149 273.736 73.4602 272.615 73.7178 270.933L75.9499 255.709"
                fill="#F9BC60"
              />
              <path
                id="Vector_28"
                d="M119.605 103.591L104.796 105.057C90.5447 106.48 78.7831 116.874 75.5637 130.891L45.7734 260.577L79.6845 266.184L75.392 284.729C75.392 284.729 93.4207 293.355 123.468 291.198L119.605 103.591Z"
                fill="#f8f8f8"
              />
              <path id="Vector_29" d="M123.468 63.4863V66.5051" stroke="#114067" strokeWidth={5} strokeMiterlimit={10} />
              <path id="Vector_30" d="M120.378 62.5386V65.5576" stroke="#114067" strokeWidth={5} strokeMiterlimit={10} />
              <path id="Vector_31" d="M120.807 79.7891V82.8079" stroke="#114067" strokeWidth={5} strokeMiterlimit={10} />
              <path id="Vector_32" d="M127.031 64.5654V67.5845" stroke="#114067" strokeWidth={5} strokeMiterlimit={10} />
              <path id="Vector_33" d="M127.031 59.9497V62.969" stroke="#114067" strokeWidth={5} strokeMiterlimit={10} />
              <path id="Vector_34" d="M130.766 64.5654V67.5845" stroke="#114067" strokeWidth={5} strokeMiterlimit={10} />
              <path id="Vector_35" d="M130.122 72.4136V69.395" stroke="#114067" strokeWidth={5} strokeMiterlimit={10} />
              <path id="Vector_36" d="M123.468 68.6621V71.6812" stroke="#114067" strokeWidth={5} strokeMiterlimit={10} />
              <path id="Vector_37" d="M127.031 69.3096V72.3281" stroke="#114067" strokeWidth={5} strokeMiterlimit={10} />
              <path id="Vector_38" d="M119.82 67.7998V70.8188" stroke="#114067" strokeWidth={5} strokeMiterlimit={10} />
              <path id="Vector_39" d="M120.807 73.751V76.77" stroke="#114067" strokeWidth={5} strokeMiterlimit={10} />
              <path id="Vector_40" d="M124.026 73.1909V76.2097" stroke="#114067" strokeWidth={5} strokeMiterlimit={10} />
              <path id="Vector_41" d="M124.542 78.2793V81.2983" stroke="#114067" strokeWidth={5} strokeMiterlimit={10} />
              <path id="Vector_42" d="M134.543 62.5386V65.5576" stroke="#114067" strokeWidth={5} strokeMiterlimit={10} />
              <path id="Vector_43" d="M130.766 59.9497V62.969" stroke="#114067" strokeWidth={5} strokeMiterlimit={10} />
              <path id="Vector_44" d="M137.333 72.4136H140.767" stroke="#114067" strokeWidth={5} strokeMiterlimit={10} />
              <g id="Group_3">
                <g id="Group_4">
                  <g id="Group_5">
                    <g id="Group_6">
                      <path id="Vector_45" d="M52.4268 267.052L50.5381 280.422" stroke="#A3A8D4" strokeMiterlimit={10} />
                    </g>
                    <g id="Group_7">
                      <path id="Vector_46" d="M56.8053 269.639L55.4316 285.553" stroke="#A3A8D4" strokeMiterlimit={10} />
                    </g>
                    <g id="Group_8">
                      <path id="Vector_47" d="M63.201 270.846L62.085 288.097" stroke="#A3A8D4" strokeMiterlimit={10} />
                    </g>
                    <g id="Group_9">
                      <path id="Vector_48" d="M69.5967 265.887L68.6523 281.413" stroke="#A3A8D4" strokeMiterlimit={10} />
                    </g>
                  </g>
                </g>
              </g>
              <path
                id="Vector_49"
                d="M208.252 254.113L210.594 277.148C210.704 278.406 210.118 279.577 209.13 280.054L207.74 280.705L207.484 283.308C207.375 284.609 206.57 285.65 205.545 285.997L203.826 286.561C203.497 288.643 202.07 290.162 200.277 290.335H200.204C199.217 290.422 198.375 289.554 198.302 288.383L197.205 288.47C195.705 288.6 194.388 287.299 194.168 285.52L193.18 276.28L191.863 276.54C190.437 276.801 189.12 275.673 188.9 273.981L186.998 258.668"
                fill="#F9BC60"
              />
              <path
                id="Vector_50"
                d="M149.527 103.596L162.209 105.063C174.413 106.487 184.485 116.886 187.242 130.909L212.753 260.654L183.713 266.263L187.389 284.817C187.389 284.817 171.95 293.446 146.219 291.289L149.527 103.596Z"
                fill="#f8f8f8"
              />
              <g id="Group_10">
                <g id="Group_11">
                  <g id="Group_12">
                    <g id="Group_13">
                      <path id="Vector_51" d="M207.055 270.071L208.673 283.441" stroke="#A3A8D4" strokeMiterlimit={10} />
                    </g>
                    <g id="Group_14">
                      <path id="Vector_52" d="M203.306 272.66L204.482 288.573" stroke="#A3A8D4" strokeMiterlimit={10} />
                    </g>
                    <g id="Group_15">
                      <path id="Vector_53" d="M197.829 273.867L198.785 291.118" stroke="#A3A8D4" strokeMiterlimit={10} />
                    </g>
                    <g id="Group_16">
                      <path id="Vector_54" d="M192.351 268.906L193.16 284.432" stroke="#A3A8D4" strokeMiterlimit={10} />
                    </g>
                  </g>
                </g>
              </g>
              <g id="Group 210">
                <path
                  id="Vector_55"
                  d="M153.01 58.5585C153.709 63.6147 153.564 68.7935 154.501 73.8252C155.484 78.8282 157.76 83.9643 162.162 86.5418C162.639 86.8428 163.199 87.1233 163.351 87.6628C163.433 87.9922 163.395 88.3339 163.321 88.6673C161.724 96.1665 154.769 102.236 147.074 102.734C141.199 103.095 135.405 100.479 131.094 96.4439C126.784 92.4091 123.933 87.0666 121.933 81.5645C119.885 75.9347 118.701 69.9146 119.214 63.9622C119.689 58.0015 121.98 52.0962 126.163 47.8189C128.631 45.2978 131.915 43.3086 135.447 43.164C138.115 43.0597 140.551 43.6427 142.946 44.7608C144.95 45.7139 147.091 45.8807 148.736 47.5703C150.155 49.0538 151.05 50.965 151.699 52.9376C152.38 54.7621 152.732 56.6685 153.01 58.5585Z"
                  fill="#114067"
                />
                <path
                  id="Vector_56"
                  d="M153.356 74.0753C153.672 78.9294 153.482 84.137 150.756 88.1564C148.031 92.1758 141.961 94.2815 138.11 91.3216C138.172 95.2245 139.373 100.464 141 103.977C136.792 104.71 132.1 103.086 127.98 101.855C126.886 101.532 125.807 101.136 125.014 100.336C124.352 99.6442 123.924 98.771 123.579 97.8772C121.337 92.593 119.478 87.161 117.993 81.6182C115.815 73.4317 114.639 64.0688 119.294 56.9802C121.051 54.339 123.474 52.1966 126.032 50.3178C130.741 46.8192 136.57 43.8817 142.311 45.1638C147.691 46.3261 148.975 51.2018 150.242 55.8016C151.903 61.7727 152.943 67.9161 153.356 74.0753Z"
                  fill="#F9BC60"
                />
                <path
                  id="Vector_57"
                  d="M145.992 69.4364L160.624 72.7037L160.367 62.5349L145.735 59.2676L145.992 69.4364Z"
                  stroke="#114067"
                  strokeMiterlimit={10}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  id="Vector_58"
                  d="M127.211 65.2426L141.843 68.5099L141.586 58.341L126.954 55.0737L127.211 65.2426Z"
                  stroke="#114067"
                  strokeMiterlimit={10}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  id="Vector_59"
                  d="M145.81 62.5898L141.624 61.6552"
                  stroke="#114067"
                  strokeMiterlimit={10}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  id="Vector_60"
                  d="M131.177 52.361C126.597 57.7165 124.769 65.903 125.487 72.4413C126.291 79.8154 130.215 86.7975 136.048 91.3278C135.006 91.9896 133.643 91.9964 132.474 91.6576C131.305 91.3189 130.256 90.6179 129.199 89.954C130.79 92.0594 133.329 93.4041 135.992 93.4932C135.725 93.4724 133.079 96.615 132.564 97.0055C131.179 97.9798 129.849 98.5383 128.227 98.8372C124.257 99.5453 120.453 99.5126 116.498 98.5905C113.469 97.8752 110.53 96.7524 108.033 94.8726C94.4213 84.5995 99.1217 61.4594 108.857 50.255C113.778 44.5871 120.789 40.708 128.262 39.8099C134.303 39.0586 143.988 40.7935 146.97 46.943C146.068 47.6748 144.084 46.8041 142.886 46.77C141.421 46.715 139.963 46.9728 138.584 47.4037C135.586 48.2899 133.126 50.0741 131.177 52.361Z"
                  fill="#114067"
                />
                <g id="Group_17">
                  <g id="Group_18">
                    <path
                      id="Vector_61"
                      d="M135.563 63.024C134.377 62.7593 134.791 60.9072 135.976 61.1718C137.162 61.4365 136.748 63.2887 135.563 63.024Z"
                      fill="#114067"
                    />
                  </g>
                </g>
                <g id="Group_19">
                  <g id="Group_20">
                    <path
                      id="Vector_62"
                      d="M149.33 66.6815C148.144 66.4168 148.558 64.5646 149.743 64.8293C150.929 65.094 150.515 66.9462 149.33 66.6815Z"
                      fill="#114067"
                    />
                  </g>
                </g>
              </g>
              <g id="Group 12 Copy 5">
                <g id="Group 8">
                  <path
                    id="Shape"
                    d="M141.996 103.307L141.978 102.493L141.978 102.493L141.996 103.307ZM141.205 102.496L140.393 102.494L140.393 102.494L141.205 102.496ZM144.864 103.367L144.919 102.555L144.864 103.367ZM155.558 110.323L154.9 110.799L155.558 110.323ZM163.892 130.226L163.108 130.437L163.892 130.226ZM164.869 130.778L165.111 131.554L164.869 130.778ZM165.426 129.742L164.642 129.953L165.426 129.742ZM156.841 109.304L157.499 108.827L156.841 109.304ZM145.008 101.711L144.953 102.523L145.008 101.711ZM142.004 101.648L142.021 102.462L142.021 102.462L142.004 101.648ZM118.289 103.628L117.99 102.873L118.289 103.628ZM103.35 115.098L102.61 114.764L102.61 114.764L103.35 115.098ZM118.692 102.6L117.964 102.962L118.692 102.6ZM117.576 102.181L117.276 101.425L117.576 102.181ZM101.8 114.437L102.539 114.771L102.539 114.771L101.8 114.437ZM102.254 115.48L101.935 116.229L101.935 116.229L102.254 115.48ZM142.013 104.12C141.087 104.142 140.389 103.378 140.393 102.494L142.016 102.499C142.016 102.507 142.017 102.51 142.018 102.51C142.018 102.511 142.017 102.51 142.015 102.507C142.013 102.505 142.008 102.501 142 102.498C141.992 102.494 141.984 102.493 141.978 102.493L142.013 104.12ZM144.81 104.179C143.858 104.117 142.925 104.099 142.013 104.12L141.978 102.493C142.939 102.471 143.92 102.49 144.919 102.555L144.81 104.179ZM154.9 110.799C151.795 106.479 148.424 104.415 144.81 104.179L144.919 102.555C149.163 102.832 152.929 105.27 156.217 109.846L154.9 110.799ZM163.108 130.437C160.779 121.652 158.023 115.145 154.9 110.799L156.217 109.846C159.505 114.421 162.324 121.145 164.676 130.015L163.108 130.437ZM165.111 131.554C164.231 131.831 163.338 131.306 163.108 130.437L164.676 130.015C164.677 130.02 164.678 130.019 164.676 130.016C164.674 130.013 164.67 130.01 164.665 130.007C164.659 130.004 164.652 130.001 164.644 130.001C164.636 130 164.629 130.001 164.628 130.001L165.111 131.554ZM166.21 129.532C166.434 130.377 165.963 131.285 165.111 131.554L164.628 130.001C164.622 130.003 164.628 130.004 164.636 129.989C164.644 129.975 164.644 129.962 164.642 129.953L166.21 129.532ZM157.499 108.827C160.95 113.63 163.834 120.569 166.21 129.532L164.642 129.953C162.289 121.077 159.468 114.353 156.182 109.781L157.499 108.827ZM145.062 100.899C149.892 101.214 154.03 104 157.499 108.827L156.182 109.781C152.896 105.208 149.152 102.797 144.953 102.523L145.062 100.899ZM141.987 100.835C142.992 100.811 144.018 100.831 145.062 100.899L144.953 102.523C143.957 102.458 142.979 102.439 142.021 102.462L141.987 100.835ZM140.393 102.494C140.398 101.624 141.08 100.856 141.987 100.835L142.021 102.462C142.027 102.461 142.031 102.46 142.033 102.459C142.035 102.458 142.033 102.459 142.03 102.462C142.022 102.471 142.016 102.483 142.016 102.499L140.393 102.494ZM118.589 104.384C114.788 105.909 111.573 107.741 109.097 109.668C106.613 111.602 104.916 113.597 104.089 115.432L102.61 114.764C103.586 112.602 105.499 110.411 108.104 108.383C110.718 106.349 114.071 104.445 117.99 102.873L118.589 104.384ZM119.419 102.238C119.831 103.074 119.438 104.043 118.589 104.384L117.99 102.873C117.993 102.871 117.99 102.872 117.983 102.879C117.977 102.885 117.971 102.894 117.966 102.905C117.962 102.917 117.96 102.93 117.96 102.942C117.96 102.948 117.961 102.952 117.962 102.956C117.963 102.96 117.964 102.962 117.964 102.962L119.419 102.238ZM117.276 101.425C118.08 101.103 119.031 101.45 119.419 102.238L117.964 102.962C117.964 102.962 117.964 102.961 117.963 102.96C117.962 102.959 117.961 102.957 117.958 102.955C117.952 102.95 117.943 102.944 117.931 102.939C117.904 102.929 117.884 102.933 117.876 102.936L117.276 101.425ZM101.061 114.104C103.227 109.3 109.329 104.614 117.276 101.425L117.876 102.936C110.066 106.069 104.446 110.544 102.539 114.771L101.061 114.104ZM101.935 116.229C101.147 115.893 100.671 114.968 101.061 114.104L102.539 114.771C102.545 114.76 102.548 114.746 102.547 114.733C102.547 114.72 102.545 114.713 102.544 114.711C102.542 114.707 102.546 114.72 102.573 114.731L101.935 116.229ZM104.089 115.432C103.706 116.281 102.714 116.561 101.935 116.229L102.573 114.731C102.6 114.743 102.621 114.74 102.631 114.737C102.635 114.735 102.634 114.735 102.628 114.739C102.623 114.744 102.616 114.753 102.61 114.764L104.089 115.432Z"
                    fill="black"
                  />
                  <path
                    id="Oval"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M169.078 145.042C164.994 146.973 160.188 145.347 158.345 141.41C156.502 137.473 158.318 132.716 162.403 130.786C166.487 128.855 171.293 130.481 173.136 134.418C174.98 138.355 173.163 143.112 169.078 145.042Z"
                    fill="#BCBCBC"
                  />
                  <path
                    id="Oval Copy 10"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M167.538 141.752C165.339 142.792 162.751 141.916 161.759 139.796C160.766 137.676 161.744 135.115 163.944 134.075C166.143 133.036 168.73 133.912 169.723 136.031C170.716 138.151 169.737 140.713 167.538 141.752Z"
                    fill="black"
                  />
                  <path
                    id="Path 8"
                    d="M101.293 115.957C101.293 115.957 110.258 124.221 109.852 134.235C109.459 139.332 103.636 140.745 103.636 140.745"
                    stroke="black"
                    strokeWidth={1.625}
                    strokeLinecap="round"
                  />
                  <path
                    id="Path 8 Copy"
                    d="M101.495 115.747C101.495 115.747 90.9778 122.716 89.3513 132.649C88.4013 138.508 93.6975 140.916 93.6975 140.916"
                    stroke="black"
                    strokeWidth={1.625}
                    strokeLinecap="round"
                  />
                  <path
                    id="Oval_2"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M103.373 142.657C102.43 143.102 101.321 142.727 100.896 141.818C100.471 140.91 100.89 139.812 101.832 139.367C102.775 138.921 103.884 139.297 104.309 140.205C104.735 141.114 104.315 142.211 103.373 142.657Z"
                    fill="#BCBCBC"
                  />
                  <path
                    id="Oval Copy 11"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M95.1771 142.957C94.2346 143.403 93.1256 143.027 92.7002 142.119C92.2748 141.21 92.6941 140.113 93.6366 139.667C94.5792 139.222 95.6881 139.597 96.1135 140.505C96.5389 141.414 96.1197 142.512 95.1771 142.957Z"
                    fill="#BCBCBC"
                  />
                  <path
                    id="Path 9"
                    d="M106.613 122.372C106.613 122.372 100.706 116.681 94.7354 121.735"
                    stroke="black"
                    strokeWidth={1.625}
                    strokeLinecap="round"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g id="svg-partnership--patient">
        <text
          id="patient-label"
          fill="#050D3D"
          xmlSpace="preserve"
          style={{
            whiteSpace: 'pre',
          }}
          fontFamily="Montserrat"
          fontSize={16}
          fontWeight={600}
          letterSpacing="0px"
        >
          <tspan x={759} y={311.214}>
            {t('partnership_patient')}
          </tspan>
        </text>
        <path
          id="Vector_63"
          d="M849.84 126.535C846.734 116.387 838.65 108.977 832.51 100.71C824.299 89.6679 821.52 78.2793 818.032 65.2116C816.543 59.6086 814.181 53.823 810.512 49.4793C808.35 46.9059 805.716 44.8618 802.538 43.6207C797.161 41.5401 791.784 42.6534 786.861 45.2816C781.72 48.0192 778.868 43.639 773.51 44.0222C767.987 44.4238 763.228 48.3842 760.394 53.1477C756.398 59.9006 754.727 68.6793 753.982 76.3812C752.729 89.3029 749.749 102.225 739.849 111.259C737.179 113.686 734.164 115.785 732.002 118.669C727.079 125.239 727.806 135.058 732.656 141.683C737.506 148.308 745.753 151.886 753.927 152.305C758.959 152.561 763.991 151.758 769.023 151.959C778.523 152.324 787.479 156.247 796.725 158.492C805.517 160.628 814.672 161.285 823.682 160.372C830.185 159.715 836.852 158.164 842.011 154.13C849.985 147.907 852.819 136.263 849.84 126.535ZM797.469 124.254L788.114 125.349L778.759 124.254L757.506 120.147L760.122 112.044C760.122 112.044 774.763 110.93 779.668 109.47C782.538 108.612 782.737 103.52 782.392 99.4505C772.928 95.6542 771.838 80.0862 771.838 72.95C773.273 71.7455 774.708 70.5409 776.144 69.3363C777.651 68.077 780.648 65.3941 781.775 62.7295C783.428 65.4854 785.735 67.8763 788.496 69.5371C792.292 71.8367 797.415 73.5341 798.323 77.896C798.759 80.0497 797.978 82.2945 798.378 84.4664C798.777 86.6383 800.267 88.2991 802.065 89.6497C800.521 94.1759 797.978 98.0816 793.818 99.6147C793.509 103.666 793.746 108.631 796.561 109.47C801.466 110.93 816.107 112.044 816.107 112.044L818.723 120.147L797.469 124.254Z"
          fill="#365A8E"
        />
        <path
          id="Vector_64"
          d="M839.568 284.756C836.306 258.412 822.391 227.353 813.735 201.342L766.231 199.678C766.231 199.678 748.444 223.582 743.178 284.756H839.568Z"
          fill="#E6E9F5"
        />
        <path
          id="Vector_65"
          d="M816.107 112.043C816.107 112.043 801.466 110.93 796.561 109.47C791.656 108.01 794.563 94.1573 794.563 94.1573L788.114 91.0364L781.666 94.1573C781.666 94.1573 784.572 108.01 779.667 109.47C774.763 110.93 760.122 112.043 760.122 112.043L757.506 120.147L778.759 124.253L788.114 125.348L797.469 124.253L818.723 120.147L816.107 112.043Z"
          fill="#F9BC60"
        />
        <path
          id="Vector_66"
          d="M760.122 112.043C760.122 112.043 787.224 133.25 814.254 111.897C814.254 111.897 819.504 111.112 824.645 114.872C840.939 126.826 874.562 156.685 872.691 184.225C870.239 220.435 854.98 218.975 848.441 208.025C841.901 197.074 842.446 176.834 842.446 176.834L827.642 173.841C827.642 173.841 822.319 193.661 814.181 200.779C814.181 200.779 782.846 206.82 766.334 199.739C766.334 199.739 761.866 189.062 757.706 177.381L744.899 186.142C744.899 186.142 743.264 232.061 719.831 210.78C696.398 189.5 739.086 114.05 760.122 112.043Z"
          fill="#FDEFE3"
        />
        <path
          id="Vector_67"
          d="M844.027 198.407C835.471 191.709 820.139 179.134 812.91 169.698C812.91 169.698 805.28 161.303 805.644 153.638C805.934 147.432 800.049 143.508 797.796 142.231C796.943 141.738 796.27 140.953 796.016 139.986C795.653 138.69 796.016 137.139 799.667 137.029C806.025 136.847 812.383 141.774 812.383 141.774L818.159 119.417C818.632 117.555 820.666 116.497 822.41 117.282C823.064 117.574 823.609 118.085 823.827 118.961C824.554 121.881 822.011 135.186 822.011 135.186C822.011 135.186 826.189 134.109 827.642 136.117C827.642 136.117 830.73 137.577 830.911 140.132C830.911 140.132 835.271 141.957 834.181 144.512L832.492 150.462C832.492 150.462 833.927 158.328 830.021 162.946C825.952 167.746 856.524 173.166 861.792 183.752C864.844 189.902 864.354 197.458 863.409 202.714C862.81 206 859.213 207.77 856.252 206.237C851.929 204.028 847.841 201.4 844.027 198.407Z"
          fill="#F9BC60"
        />
        <path
          id="Vector_68"
          d="M787.388 164.369L773.219 161.686C772.147 161.485 771.439 160.445 771.639 159.368L776.961 131.043C777.161 129.966 778.196 129.254 779.268 129.455L793.437 132.138C794.509 132.338 795.217 133.379 795.017 134.456L789.695 162.781C789.495 163.858 788.46 164.57 787.388 164.369Z"
          fill="#365A8E"
        />
        <path
          id="Vector_69"
          d="M750.004 162.799C754.654 161.521 760.285 160.317 766.952 159.477C766.952 159.477 771.857 141.828 774.945 143.161C778.033 144.493 794.745 147.869 794.563 150.388C794.381 152.907 793.292 155.206 791.657 155.06C791.657 155.06 794.2 157.561 791.057 159.514C791.057 159.514 792.256 160.755 790.185 163.054C790.185 163.054 790.312 165.354 788.496 165.536C785.88 165.792 777.96 163.054 777.96 163.054C777.96 163.054 778.196 164.35 777.597 166.394C777.197 167.727 775.907 169.004 774.581 170.008C772.492 171.614 770.458 173.293 768.569 175.136C762.302 181.232 748.605 193.643 737.27 197.877C731.076 200.195 729.205 195.961 729.168 190.139C729.096 177.363 737.724 166.175 750.004 162.799Z"
          fill="#F9BC60"
        />
        <path
          id="Vector_70"
          d="M828.041 133.798C826.897 137.868 825.262 141.883 823.536 145.716C822.537 147.924 821.92 151.045 824.681 152.323C824.953 152.451 825.226 152.524 825.516 152.524C825.807 152.524 826.098 152.396 826.279 152.159"
          stroke="#E16162"
          strokeMiterlimit={10}
        />
        <path
          id="Vector_71"
          d="M832.038 138.762C830.512 141.938 828.986 145.114 827.46 148.289C826.988 149.257 826.516 150.242 826.37 151.301C826.207 152.359 826.407 153.527 827.133 154.312C827.86 155.097 829.204 155.334 830.022 154.659C831.002 153.856 831.402 152.651 831.656 151.41"
          stroke="#E16162"
          strokeMiterlimit={10}
        />
        <path
          id="Vector_72"
          d="M823.173 133.707C821.956 135.988 820.903 138.379 820.031 140.825C819.231 143.033 818.087 145.716 818.305 148.107C818.378 148.929 818.741 149.768 819.449 150.206C820.012 150.553 820.721 150.589 821.375 150.535C821.974 150.48 822.628 150.279 822.919 149.75"
          stroke="#E16162"
          strokeMiterlimit={10}
        />
        <path id="Vector_73" d="M813.691 150.388C816.216 150.315 818.741 151.72 819.994 153.929" stroke="#E16162" strokeMiterlimit={10} />
        <path id="Vector_74" d="M793.11 155.644L784.881 152.158L780.158 151.264" stroke="#E16162" strokeMiterlimit={10} />
        <path id="Vector_75" d="M792.419 160.024L783.173 156.648L779.758 156.064" stroke="#E16162" strokeMiterlimit={10} />
        <path id="Vector_76" d="M790.894 163.492L782.12 160.535L780.158 160.024" stroke="#E16162" strokeMiterlimit={10} />
        <path
          id="Vector_77"
          d="M788.496 69.5553C792.292 71.8549 797.415 73.5523 798.323 77.9142C798.759 80.0679 797.978 82.3127 798.377 84.4846C799.013 87.934 802.374 90.0694 805.407 91.785C805.97 92.1135 806.57 92.442 807.224 92.4603C808.459 92.4968 809.458 91.4382 810.076 90.3614C812.946 85.4154 811.729 79.1918 810.112 73.6983C808.132 66.9454 805.135 59.6998 798.85 56.5606C795.525 54.8997 791.711 54.6442 788.023 54.407C786.388 54.2975 781.157 53.0564 779.831 54.0419C778.323 55.1553 779.522 57.7286 780.103 59.2982C781.684 63.5142 784.645 67.2192 788.496 69.5553Z"
          fill="#365A8E"
        />
        <path
          id="Vector_78"
          d="M776.143 69.3358C774.472 70.7411 772.801 72.1282 771.13 73.5335C770.603 73.9715 770.022 74.4461 769.331 74.5191C768.296 74.6286 767.37 73.7525 766.916 72.8035C766.207 71.3252 766.28 69.5548 766.843 68.0035C767.388 66.4522 768.369 65.1016 769.44 63.8423C771.493 61.4332 777.433 55.2461 780.848 58.075C784.99 61.5062 778.596 67.2735 776.143 69.3358Z"
          fill="#365A8E"
        />
        <path
          id="Vector_79"
          d="M798.36 84.4836C797.96 82.33 798.759 80.0668 798.305 77.9132C797.397 73.533 792.292 71.8539 788.478 69.5542C785.717 67.8934 783.428 65.5025 781.757 62.7466C780.63 65.4112 777.633 68.0941 776.125 69.3535C774.69 70.558 773.255 71.7626 771.82 72.9672C771.82 80.5231 773.037 97.4601 784.064 99.997C786.589 101.366 789.622 101.439 792.202 100.18L792.601 99.997C797.451 98.8289 800.34 94.6129 802.029 89.6851C800.249 88.3163 798.759 86.6555 798.36 84.4836Z"
          fill="#F9BC60"
        />
        <path
          id="Vector_80"
          d="M787.805 89.5034C787.951 89.5947 788.114 89.6859 788.278 89.6312C788.441 89.5764 788.514 89.4122 788.623 89.2661C789.041 88.6456 789.894 88.4631 790.639 88.4813C791.402 88.4996 792.165 88.6456 792.892 88.4448C792.764 89.8137 792.219 91.1278 791.329 92.1864C790.766 92.8617 790.021 93.4457 789.149 93.5917C788.75 93.6647 788.35 93.6282 787.951 93.537C786.57 93.2632 784.971 92.1316 784.517 90.7263C783.863 88.6091 786.461 88.7734 787.805 89.5034Z"
          fill="#E16162"
        />
      </g>
    </svg>
  );
}
